// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Partnership_contentWrapper__yU-EN","container":"Partnership_container__boV-4"};